import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid } from 'semantic-ui-react';
import { SearchBar, USER_PERMISSIONS } from 'dyl-components';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import AddUserReportModal from './AddUserReportModal';
import { useParams } from 'react-router-dom';
import CampaignOwnerDropdown from './CampaignOwnerDropdown';
import RestrictedView from 'shared/RestrictedView';

const UsersToolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, isCampaignInactive }) => {
    const [selectedUsers, , areUsersInAllPagesSelected] = useContext(BulkActionsContext);
    const { id } = useParams();

    const { isReadingUsers, campaign, user_id } = useSelector(state => ({
        isReadingUsers: state.campaign_users.isReadingUsers,
        count: state.campaign_users.count,
        campaign: state.campaigns.campaign,
        user_id: state.auth.user_id,
    }));

    const hasSelectedUsers = selectedUsers.length || areUsersInAllPagesSelected;

    const [, setIsBulkActionsModalOpen] = useState(false);
    const [isAddUserReportModalOpen, setAddUserReportModalOpen] = useState(false);

    const onOpenBulkActionsModal = () => {
        setIsBulkActionsModalOpen(true);
    }
    const isCompany = Object.keys(campaign?.is_company_campaign || []).length > 0;
    const isOwner = campaign.user_owner_id !== user_id;

    return (
        <React.Fragment>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <CampaignOwnerDropdown />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns='equal' verticalAlign='middle'>
                    <Grid.Column width={5}>
                        <div className='ModulesToolbar'>
                            <SearchBar
                                isSearching={isReadingUsers}
                                search={search}
                                searchFcn={onSearchSubmit}
                                cancelFcn={cancelFunction}
                                placeholder={'Search by User Name'}
                                onChange={onChangeSearch}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column floated='right'>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.CAMPAIGNS_ADD} userRestrict modifiers={isCompany ? 'company' : 'personal'}>
                            <Button floated='right' primary disabled={isCampaignInactive || isOwner} onClick={() => { setAddUserReportModalOpen(true) }}>
                                + User
                            </Button>
                        </RestrictedView>
                        <Button floated='right' primary disabled={!hasSelectedUsers || isCampaignInactive} onClick={onOpenBulkActionsModal}>
                            Bulk Action
                        </Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <AddUserReportModal
                campaignId={id}
                isModalOpen={isAddUserReportModalOpen}
                onModalClose={() => { setAddUserReportModalOpen(false) }}
            />
        </React.Fragment>

    )
}

export default UsersToolbar;
